import React, { useState } from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { Field, reduxForm } from "redux-form";
import { Button } from "reactstrap";
import EyeIcon from "mdi-react/EyeIcon";
import KeyVariantIcon from "mdi-react/KeyVariantIcon";
import Modal from "../../../shared/components/Modal";
import { useModalAlert } from "../../GeneralComponents";

const renderField = ({
  input,
  disabled,
  placeholder,
  type,
  meta: { touched, error },
  style,
}) => (
  <div
    className="form__form-group-input-wrap form__form-group-input-wrap--error-above"
    style={style}
  >
    <input
      {...input}
      placeholder={placeholder}
      type={type}
      disabled={disabled}
    />
    {touched && error && (
      <span className="form__form-group-error">{error}</span>
    )}
  </div>
);

renderField.propTypes = {
  input: PropTypes.shape().isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

renderField.defaultProps = {
  placeholder: "",
  meta: null,
  type: "text",
};

const AccountForm = () => {
  const [isPasswordShown, setIsPasswordShown] = useState(false);
  const [isPasswordShown2, setIsPasswordShown2] = useState(false);
  const [isPasswordShown3, setIsPasswordShown3] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPassword2, setNewPassword2] = useState("");
  const [errors, setErrors] = useState({});
  const { showModalAlert } = useModalAlert();

  const showPassword = () => {
    setIsPasswordShown(!isPasswordShown);
  };

  const showPassword2 = () => {
    setIsPasswordShown2(!isPasswordShown2);
  };

  const showPassword3 = () => {
    setIsPasswordShown3(!isPasswordShown3);
  };

  const validatePassword = () => {
    let newErrors = {};

    if (!oldPassword) newErrors.oldpassword = "Ingrese la contraseña actual";
    else delete newErrors.oldpassword;

    if (!newPassword) newErrors.newpassword = "Ingrese la contraseña nueva";
    else delete newErrors.newpassword;

    if (newPassword.length < 5)
      newErrors.newpassword = "La contraseña debe tener minimo 6 caracteres";
    else delete newErrors.newpassword;

    if (!newPassword2)
      newErrors.newpasswordtwo =
        "Ingrese la contraseña nuevamente la contraseña nueva";
    else delete newErrors.newpasswordtwo;

    if (!(newPassword === newPassword2))
      newErrors.newpasswordtwo = "Las contraseñas nuevas con coinciden";
    else delete newErrors.newpasswordtwo;

    setErrors(newErrors);

    if (!(Object.keys(newErrors).length > 0)) {
      //return false;
      setOpenModal(true);
    }
  };

  const updatePassword = async () => {
    setOpenModal(false);

    const user = JSON.parse(sessionStorage.getItem("usuario"));

    const dataSend = {
      id_usuario: user.id_usuario,
      password: oldPassword,
      nueva_password: newPassword,
    };

    await fetch(process.env.REACT_APP_PUBLIC_URL + "usuario/cambiar-password", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(dataSend),
    })
      .then((response) => {
        return response.text();
      })
      .then((data) => {
        showModalAlert("success", "Se actualizo correctamente la contraseña");
      })
      .catch((error) => {
        showModalAlert("danger", "Error al actualizar la contraseña");
        console.error("Error:", error);
      });
  };

  return (
    <form className="form">
      <div className="form__form-group " style={{ marginTop: 30 }}>
        <span className="form__form-group-label">Contraseña Actual</span>
        <div className="form__form-group-field">
          <div className="form__form-group-icon">
            <KeyVariantIcon />
          </div>
          <Field
            name="oldpassword"
            component={renderField}
            type={isPasswordShown ? "text" : "password"}
            placeholder="Password"
            value={oldPassword}
            onChange={(e) => {
              setOldPassword(e.target.value);
            }}
            meta={{
              touched: errors.hasOwnProperty("oldpassword"),
              error: errors.hasOwnProperty("oldpassword")
                ? errors.oldpassword
                : "",
            }}
          />
          <button
            className={`form__form-group-button${isPasswordShown ? " active" : ""}`}
            type="button"
            onClick={showPassword}
          >
            <EyeIcon />
          </button>
        </div>
      </div>
      <div className="form__form-group">
        <span className="form__form-group-label" style={{ marginTop: 10 }}>
          Contraseña Nueva
        </span>
        <div className="form__form-group-field">
          <div className="form__form-group-icon">
            <KeyVariantIcon />
          </div>
          <Field
            name="newpassword"
            component={renderField}
            type={isPasswordShown2 ? "text" : "password"}
            placeholder="Password"
            value={newPassword}
            onChange={(e) => {
              setNewPassword(e.target.value);
            }}
            meta={{
              touched: errors.hasOwnProperty("newpassword"),
              error: errors.hasOwnProperty("newpassword")
                ? errors.newpassword
                : "",
            }}
          />
          <button
            className={`form__form-group-button${isPasswordShown2 ? " active" : ""}`}
            type="button"
            onClick={showPassword2}
          >
            <EyeIcon />
          </button>
        </div>
      </div>
      <div className="form__form-group">
        <span className="form__form-group-label" style={{ marginTop: 10 }}>
          Repetir Contraseña Nueva
        </span>
        <div className="form__form-group-field">
          <div className="form__form-group-icon">
            <KeyVariantIcon />
          </div>
          <Field
            name="newpasswordtwo"
            component={renderField}
            type={isPasswordShown3 ? "text" : "password"}
            placeholder="Password"
            value={newPassword2}
            onChange={(e) => {
              setNewPassword2(e.target.value);
            }}
            meta={{
              touched: errors.hasOwnProperty("newpasswordtwo"),
              error: errors.hasOwnProperty("newpasswordtwo")
                ? errors.newpasswordtwo
                : "",
            }}
          />
          <button
            className={`form__form-group-button${isPasswordShown3 ? " active" : ""}`}
            type="button"
            onClick={showPassword3}
          >
            <EyeIcon />
          </button>
        </div>
      </div>
      <Button color="primary" onClick={validatePassword}>
        Actualizar
      </Button>
      <Modal
        color="warning"
        title="¿Estas seguro que deseas cambiar tu contraseña?"
        message=""
        modal={openModal}
        onOk={updatePassword}
        toggle={() => {
          setOpenModal(false);
        }}
      />
    </form>
  );
};

AccountForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({
  form: "account_lock_form", // a unique identifier for this form
})(AccountForm);
